import script from "./AboutLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutLogo.vue?vue&type=script&setup=true&lang=ts"

import "./AboutLogo.vue?vue&type=style&index=0&id=ec306ba0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec306ba0"]])

export default __exports__